<template>
  <div
    :class="{ 'sticky-cta-position--visible': isStickyButtonVisible }"
    class="sticky-cta-position position-fixed d-flex w-100 justify-content-center"
  >
    <slot />
  </div>
</template>

<script>
export default defineNuxtComponent({
  data() {
    return {
      isStickyButtonVisible: false,
    }
  },

  computed: {
    targetedElements() {
      return document.querySelectorAll('.hide-sticky-button')
    },
  },

  mounted() {
    window.addEventListener('scroll', this.hasTargetedElementsInViewport)
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.hasTargetedElementsInViewport)
  },

  methods: {
    hasTargetedElementsInViewport() {
      const isElementsInViewport = []

      this.targetedElements.forEach(ref => {
        isElementsInViewport.push(
          this.checkVisibility(ref) && this.isInViewport(ref)
        )
      })

      this.isStickyButtonVisible = !isElementsInViewport.includes(true)
    },

    checkVisibility(element) {
      if (typeof element.checkVisibility === 'function') {
        return element.checkVisibility()
      } else {
        return this.isInViewport(element)
      }
    },

    isInViewport(element) {
      const rect = element.getBoundingClientRect()

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      )
    },
  },
})
</script>

<style lang="scss">
.sticky {
  &-cta-position {
    bottom: -5rem;
    opacity: 0;
    transition: all ease 200ms;
    pointer-events: none;

    &--visible {
      bottom: 4.6rem;
      z-index: 1;
      opacity: 1;
    }
  }

  &-button {
    pointer-events: all;
  }
}
</style>
